/*eslint-disable */
import {
  bus
} from '../../main';
const $ = window.jQuery = require('jquery');  
// import welcome from '../welcome-popup/index';
export default {
  name: 'appFooter',
  components: {
    // 'welcome-popup' : welcome,
  },
  props: [],
  data () {
    return {
      year: new Date().getFullYear()
    }
  },
  computed: {

  },
  mounted () {
		$(document).ready(function (argument) {
			$(".ab_btn").click( function(){
        $(window).scrollTop(0);
        $(".lymphomap_main").addClass("popup_actv");
        $(".welcome_popup_wrp").toggleClass("active");
			});
			$(document).click(function(event) {
			  //if you click on anything except the modal itself or the "open modal" link, close the modal
			  if (!$(event.target).closest(".ab_btn, .light_bg_popup").length) {
        $(".lymphomap_main").removeClass("popup_actv");
				$("body").find(".welcome_popup_wrp").removeClass("active");
			  }
			});
      });
  },
  methods: {
    
  }
}
